import { render, staticRenderFns } from "./CourseScheduling.vue?vue&type=template&id=519edd4a&"
import script from "./CourseScheduling.vue?vue&type=script&lang=js&"
export * from "./CourseScheduling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports